// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","title":"Header_title__x3ga3"};